<template>
    <div>
      <el-dialog :close-on-click-modal="false"
      title="退款短信设置"
      :visible.sync="noteSetDialogVisible"
      :before-close="noteSetHandleClose"
      width="40.6%"
      center
    >
      <div class="noteMObile">
        <div class="noteMObileTwo ">
          <div>
            <span>新退款短信模板内容</span>
            <span></span>
          </div>
          <div>
            <el-input
              type="textarea"
              v-model="data.Sms"
              disabled
              
              :autosize="{ minRows: 6, maxRows: 10}"
              placeholder="请输入新退款短信模板内容"
            ></el-input>
          </div>
        </div>
        <div class="noteMObileTwo " style="margin-left:2rem;"> 
          <div>
            <span>退款短信模板内容(待审核)</span>
            <span></span>
          </div>
          <div>
            <el-input
              type="textarea"
              v-model="data.text"
              :autosize="{ minRows: 6, maxRows: 10}"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="noteFrom">
        <el-form ref="form" :model="data" >
          <el-form-item label="退款是否发送短信:">
            <el-radio-group  v-model="data.sms_flag">
              <el-radio label="1">发送</el-radio>
              <el-radio label="2">不发送</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <div class="btn">
              <el-button class="btnL" @click="settings">确认保存</el-button>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    </div>
</template>
<script>
import { getSmsTemplate , setSmsTemplate } from '@/request/scenic.js'
import { Message } from 'element-ui'
export default {
  data(){
    return{
      noteSetDialogVisible:false,
      data:{
        token: window.sessionStorage.getItem("Token"),
        text:'',
        sms_flag:'1',
        Sms:''
      },
      sms:''
    }
  },
  methods:{
    tuiSet() {
      this.noteSetDialogVisible = true;
      this.getList()
    },
    settings(){
      setSmsTemplate(this.data).then(res=>{
        if(res.data.rcode==200){
          Message.success('设置成功')
          this.noteSetDialogVisible = false
          this.data={
            token: window.sessionStorage.getItem("Token"),
            text:'',
            sms_flag:'1',
            sms_template:''
          }
        }
      })
    },
    getList(){
      let data = {
        token: window.sessionStorage.getItem("Token"),
      }
      getSmsTemplate(data).then(res=>{
        if(res.data.rcode=='200'){
          this.data.sms_flag = res.data.result.sms_flag + ''
          this.data.Sms = res.data.result.Sms
          this.data.text = res.data.result.sms_template
        }
      })
    },
    noteSetHandleClose(){
      this.noteSetDialogVisible = false
    }
  }
}
</script>
<style scoped lang="less">
.noteMObile {
  display: flex;
  height: 200px;
  .noteMObileOne {
    width: 350px;
    margin-right: 20px;
    > div:nth-child(1) {
      height: 40px;
      line-height: 40px;
      > span:nth-child(1) {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        color: #000000;
        margin-right: 10px;
      }
      > span:nth-child(2) {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        color: #3176ec;
      }
    }
    > div:nth-child(2) {
      width: 100%;
      height: 158px;
      padding: 20px;
      box-sizing: border-box;
      background: #f7f7fa;
      border-radius: 4px;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      text-align: justify;
      color: #000000;
    }
  }
  .noteMObileTwo {
    width: 350px;
    height: 220px;
    > div:nth-child(1) {
      height: 40px;
      line-height: 40px;
      > span:nth-child(1) {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        color: #000000;
        margin-right: 10px;
      }
      > span:nth-child(2) {
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        color: #7ad896;
      }
    }
    > div:nth-child(2) {
     
    }
  }
}
.btn {
    // margin: 20px 100px 10px 0;
    margin-top: 20px;
    display: flex;
    justify-content: center;
    .el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }
  /deep/.el-textarea__inner {
        width: 100%;
        height: 158px;
        padding: 20px;
        box-sizing: border-box;
        background: #f7f7fa;
        border-radius: 4px;
        font-family: "PingFang SC";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        text-align: justify;
        color: #000000;
        border: none;
        resize: none;
      }
      .noteFrom{
        margin-top: 2rem;
      }
</style>